/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
8/25/22
Interval Container
**********************************************************/
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class IntervalContainer extends Component {
  componentDidMount() {
    document.title = 'Intervals';
  }
  render() {
    return (
      <div>
        <div className="row">
          <h5>Intervals <span className="flow-text right">{ moment().format("dddd, MMMM Do YYYY") }</span></h5><hr />
        </div>
        <div>
          { this.props.children }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({

  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IntervalContainer);



/* END */



// WEBPACK FOOTER //
// ./src/interval/interval_container.jsx